import React from "react"
import { FormattedMessage } from "react-intl"
import { BackIcon, Box, Button, DialogContentText, DialogTitle, Link } from "@carrotfertility/carotene-core"
import { DialogActionsBar, DialogTitleImage } from "@carrotfertility/carotene-core-x"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { useReimbursementContext } from "#/components/context/reimbursement/GetReimbursedContext"
import { ReimbursementDialogFraming } from "../shared/layouts"
import { CannotBeSubmittedReason, getCannotBeSubmittedReason } from "./cannotBeSubmittedReason"
import { TtcPaths } from "#/utils/Paths"

export const CannotBeSubmitted = (): JSX.Element => {
  const { back } = useStateMachine()
  const { state, onExit } = useReimbursementContext()
  const reason = getCannotBeSubmittedReason(state.relatedPrimaryServiceAnswer, state.selectedPrimaryService)

  return (
    <>
      <ReimbursementDialogFraming>
        <DialogTitle>
          <FormattedMessage defaultMessage="This expense can't be submitted." />
        </DialogTitle>
        {/* Block-level, or it won't center inside the framing. */}
        <DialogTitleImage src="/images/round-error-sign.png" alt="" sx={{ display: "block" }} />
        <Box sx={{ display: "flex", flexDirection: "column", gap: (theme) => theme.spacing(theme.tokens.spacing.md) }}>
          {reason === CannotBeSubmittedReason.DENIED && (
            <DialogContentText>
              <FormattedMessage defaultMessage="This service was denied, and we're not able to process related expenses." />
            </DialogContentText>
          )}
          {reason === CannotBeSubmittedReason.NO_ADD_ONS && (
            <DialogContentText>
              <FormattedMessage defaultMessage="This service does not have any related expenses that can be reimbursed." />
            </DialogContentText>
          )}
          {reason === CannotBeSubmittedReason.NOT_RELATED && (
            <DialogContentText>
              <FormattedMessage defaultMessage="You can only submit an expense if it's related to an existing service scheduled with a Carrot Direct Pay provider." />
            </DialogContentText>
          )}
          <DialogContentText>
            <FormattedMessage
              defaultMessage="If you have questions, <link>contact us</link>."
              values={{
                link: (linkContent) => (
                  <Link href={TtcPaths.TTC_CARE_NAV} target="_blank" color="inherit">
                    {linkContent}
                  </Link>
                )
              }}
            />
          </DialogContentText>
        </Box>
      </ReimbursementDialogFraming>
      <DialogActionsBar
        primaryAction={
          <Button color="primary" onClick={onExit}>
            <FormattedMessage defaultMessage="Close" />
          </Button>
        }
        tertiaryAction={
          <Button variant="text" color="secondary" startIcon={<BackIcon />} onClick={back}>
            <FormattedMessage defaultMessage="Back" />
          </Button>
        }
      />
    </>
  )
}
